// extracted by mini-css-extract-plugin
export default {"avatar":"styles_avatar__IAR4z"};